import { CartGroup, CartItem } from '../../model/cart.model';
import { State } from './cart.reducers';
import { createAestheticSupplyCartGroup } from '../../order-checkout/shared/cart';
import { CartConstants } from '../../constants/application-constants';

const groupName = CartConstants.RECOMMENDED_SUPPLIES_GROUP_NAME;

export class RecommendedSuppliesAdapter {
    // replace collection with provided collection
    addAll(items: CartItem[], state: State) {

        const supplies = state.recommendSupplies;

        return { ...state, recommendSupplies: [ ...items ] };
    }

    removeAll(items: CartItem[], state: State) {
        return { ...state, recommendSupplies: [] };
    }

}

export const createRecommendedSuppliesAdapter = () => new RecommendedSuppliesAdapter();




